/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MagnifyingGlassIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwElEQVR4nMVUyUoDQRBtz24nFa8e9OhyVFAMKAHTVd2BnioT/8TlT+IHKH6Dgh71ogG3LzCCiooeleqeRBFm7AkGHzSESXW9V0s/pf4LFUOrGqmhDV8B0rtGfgHDt/6b5VLXiY2hSUA6BsMfuQfpeK1amyiUHCBZBEMPkkAj3YGhTcTazMrKRr8cAJ4Fw1vhP4nhJ11NFuKVp8kBeQ8ABrOFwKA2tO9JDD0CuKnf1bfbgrynlOqL0NT3RcKHuXdkoJ225Cj/iXK5PgTILS8MkmWVBdmMMDzazAzKgEbaTsU1smKURr6WoDWbTKuCgDB4EdfMI3gLZca3pw25kxK8qiykj6grgrLMIQz6OTMIkG4kSHa+Ry2idMi8VZjA0E5awW42geVSN2vqnBsGQ/dyt2LWl6Iemjye2IcGyAepLx39ekeMS7ylTSLDy1XeTu5nR/MRgpQS4/LeEiyjJY+oYpM559yAHPkdeh7a8uWsfGHtxmgUiRiXeEuEXR+JcklemMT3F5LlsF3UDC7rT1O25ftAJWmHxFCzCEk0ys6NaEPnaWWX1tbH/5zESiW+Wr8kp6oX0JrHAPkMkE96QvAv+ARWxhmkDmgIsgAAAABJRU5ErkJggg==)
 */
export const MagnifyingGlassIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15.62 17.03a9 9 0 1 1 1.41-1.41l4.68 4.67a1 1 0 0 1-1.42 1.42l-4.67-4.68ZM17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
